import { Fade, FadeProps } from '@mui/material'
import { FC, useEffect, useState } from 'react'

interface Props extends FadeProps {
  delay: number
}

const CustomFade: FC<Props> = ({ delay, children, in: In = true, ...rest }) => {
  const [isIn, setIsIn] = useState(In && delay === 0)

  useEffect(() => {
    if (!In || delay === 0) {
      setIsIn(In)
    } else {
      const timeout = setTimeout(() => {
        setIsIn(In)
      }, delay)

      return () => clearTimeout(timeout)
    }
  }, [delay, In])

  return (
    <Fade {...rest} in={isIn}>
      {children}
    </Fade>
  )
}

export default CustomFade
